export const USER_PROFILE_SOURCE = {
  PROFILE_PAGE: 'PROFILE_PAGE',
  POPUP: 'POPUP',
};
